import { render } from "./UnusableChoicesSummary.vue?vue&type=template&id=0be4cd22&scoped=true"
import script from "./UnusableChoicesSummary.vue?vue&type=script&lang=js"
export * from "./UnusableChoicesSummary.vue?vue&type=script&lang=js"

import "./UnusableChoicesSummary.vue?vue&type=style&index=0&id=0be4cd22&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be4cd22"]])

export default __exports__